module.exports = __webpack_public_path__ + "static/media/kealogo.a2f486e1.svg";